<!-- =========================================================================================
    File Name: tableFilterSorter.vue
    Description: Add filter and sorting functionality to table
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
    <b-card>
      <h4 class="heading">
        {{ $t("Clients") }}
        <feather-icon
          id="export"
          icon="DownloadCloudIcon"
          svgClasses="w-5 h-5 hover:text-danger stroke-current"
          class="ml-5"
          :title="$t('Export')"
          v-b-modal.modal-1
        />
      </h4>

      <div class="w-full mt-5 mb-4">
        <b-button
          class="br-20 btn-primary:focus"
          variant="primary"
          @click="$router.push('/company/clients/add').catch(() => {})"
          >{{ $t("Add") }}</b-button
        >
      </div>
      <b-modal
        id="modal-1"
        :title="$t('ExportToExcel')"
        :ok-title="$t('Export')"
        :cancel-title="$t('Cancel')"
        @ok="exportToExcel"
        @cancel="clearFields"
        @close="clearFields"
        class="export-options"
        centered
      >
        <b-input
          v-model="fileName"
          :placeholder="$t('FileName')"
          class="w-full"
        />
        <v-select v-model="selectedFormat" :options="formats" class="my-4"
          ><template v-slot:option="option">
            <span :class="option.icon">{{ option.label }} </span>
            <feather-icon
              v-if="selectedFormat == option.label"
              icon="CheckIcon"
              class="float-right"
              svgClasses="w-5 h-5"
            />
          </template>
        </v-select>
        <div class="flex walk-card">
          <span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
          <b-form-checkbox
            v-model="cellAutoWidth"
            size="lg"
            name="cell_width"
            switch
          >
          </b-form-checkbox>
        </div>
      </b-modal>

      <div class="export-table">
        <b-col lg="5" class="w-1/2 float-right">
          <b-form-group
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-5"
          >
            <b-input-group size="md">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                :placeholder="$t('Search')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table
          :current-page="currentPage"
          :per-page="perPage"
          :items="users"
          :fields="fields"
          :busy="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          responsive
          show-empty
          :filter="filter"
          :filter-included-fields="filterOn"
          :empty-text="$t('EmptyData')"
          :empty-filtered-text="$t('EmptyFilter')"
          @filtered="onFiltered"
     
        >
          <template #head()="data">
            <span>{{ $t(data.label) }}</span>
          </template>
          <template #cell(contact_number)="data">
            {{ data.item.contact_number || "N/A" }}
          </template>
          <template #cell(action)="data">
            <div>
              <feather-icon
                v-if="data.item.contact_number"
                v-b-tooltip.hover
                :title="$t('Call')"
                icon="PhoneIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="redirectToWalkin(data.item)"
              />

              <feather-icon
                v-b-tooltip.hover
                :title="$t('CreateRemote')"
                icon="CalendarIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="
                  $router.push('/company/appointments/add-new/' + data.item.id)
                "
              />
              <feather-icon
                v-if="false"
                v-b-tooltip.hover
                :title="$t('CreatePerson')"
                icon="UserIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
              />
              <feather-icon
                v-b-tooltip.hover
                :title="$t('Edit')"
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="$router.push('/company/clients/update/' + data.item.id)"
              />
              <!-- <feather-icon
                v-b-tooltip.hover
                :title="$t('Delete')"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="deleteUser(data.item.id)"
              /> -->
            </div>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
          class="float-right"
        ></b-pagination>
      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import vSelect from "vue-select";
import { registrationCase } from "@/utils/helper";
import { getAll, remove } from "@/api/company-users";
import { getErrorMessage } from "@/utils/helper";

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["FirstName", "LastName", "Email", "Number", "Departments"],
      headerVal: [
        "first_name",
        "last_name",
        "email",
        "contact_number",
        "department_names",
      ],
      staffs: [],
      users: [],
      activePrompt: false,
      popupActivo: false,
      daily: "",
      dailyUnlimited: false,
      weekly: "",
      weeklyUnlimited: false,
      monthly: "",
      monthlyUnlimited: false,
      staff_id: "",
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,

      perPage: 100,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      totalRows: 1,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      fields: [
        {
          key: "last_name",
          label: "LastName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "first_name",
          label: "FirstName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "contact_number",
          label: "ContactNumber",
          sortable: true,
          sortDirection: "desc",
        },

        { key: "action", label: "Action" },
      ],
      disabled: true,
    };
  },
  computed: {
    rows() {
      return this.users.length;
    },
  },
  created() {
    this.getUsers();
  },

  watch: {},
  methods: {
    redirectToWalkin(data) {
      let str = JSON.stringify(data);
      localStorage.setItem("Staff-users-contact", str);
      this.$router.push("/company/walkin").catch(() => {});
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    /**
     *
     * getUsers   method  for appointment from listing
     **/
    async getUsers() {
      this.success = "";
      this.error = "";
      this.show = true;
      let id = this.$store.getters.currentUser.id;
      try {
        const response = await getAll();
        this.show = false;

        if (response.status == 200 && response.data.status == "success") {
          this.users = response.data.data;
        }
      } catch (error) {
        console.error(error);
        this.$log.error("List.vue | Function : getUsers()", error);
        this.$toasted.show(getErrorMessage(error), {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
      }
    },

    checkMessage() {
      this.disabled = this.rejectMessage.length ? false : true;
    },
    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.users;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = [
          "FirstName",
          "LastName",
          "Email",
          "Number",
          "Department",
        ];
        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.filename = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },

    /**
     *
     * deleteUser   method  for delete  staff from listing
     **/
    async deleteUser(id) {
      try {
        const result = await this.$swal({
          title: this.$t("DeleteUnioUserMessage"),

          type: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("Yes"),
          confirmButtonColor: "#7367F0",
          cancelButtonText: this.$t("No"),
          showCloseButton: true,
          showLoaderOnConfirm: true,
        });
        if (result.value) {
          this.show = true;
          await remove(id);
          this.$toasted.show(this.$t("ClientDelete"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        }
      } catch (error) {
        this.$log.error(
          "List.vue | Function : deleteUser() | Error :",
          error
        );
        this.show = false;
        // Error response
        console.error(error);
        this.$toasted.show(getErrorMessage(error), {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
        return false;
      }
      this.show = false;
      this.getUsers();
    },
  },
};
</script>

<style lang="stylus" scope>
.heading {
  margin-bottom: 20px;
}

.action {
  margin-left: 20px;
  display: inline;
}

.con-vs-tooltip {
  display: inline;
}
</style>